/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { DateTime } from './dateTime';
import { ReactivationPetition } from './reactivationPetition';
import { UserBasic } from './userBasic';

export interface DeactivationIncident { 
    entity_id: string;
    created: Date;
    modified: Date;
    total_account_deactivations: number;
    reason: string;
    profile_view: UserBasic;
    reactivation_petition?: ReactivationPetition;
}